import WidgetPageLayout, { WidgetPageLayoutProps } from './WidgetPageLayout';

export default WidgetPageLayout;
export type { WidgetPageLayoutProps };
